import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=f8b2b652"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports